export default {"src":"/_next/static/media/down_arrow_icon.bb3ceaaa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};